import React from 'react';

import ResponseError from './ResponseError';
import ResponseResult from './ResponseResult';

const TheError = ({ error }) => {
  return (
    <div className="result-container">
      <ResponseError
        variant="inline"
        title="Error"
        error={error}
      />
    </div>
  );
};

const TheResult = ({ result }) => {
  return (
    <div className="result-container">
      <ResponseResult
        variant="inline"
        title="Error"
        result={result}
      />
    </div>
  );
};

export { TheError, TheResult };
